enum AvailabilityAction {
  ContinuePurchase = 'ContinuePurchase',
  ContinueReservation = 'ContinueReservation',
  GetStarted = 'GetStarted',
  GetStartedDisabled = 'GetStartedDisabled',
  None = 'None',
  NotAvailableInCA = 'NotAvailableInCA',
  NotifyMe = 'NotifyMe',
  OutOfMarket = 'OutOfMarket',
  PreOrderNow = 'PreOrderNow',
  PreOrderNowDisabled = 'PreOrderNowDisabled'
}

export default AvailabilityAction;
